import { createIcon } from './create-icon';

export const CalendarIcon = createIcon(
  'CalendarIcon',
  <>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </>,
);
